import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

import { fieldShape } from './index.shape';
import { addClassName, getCorrectDate } from './index.utils';

import './index.scss';

/**
 * text field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const DateCommon = props => {
  const {
    field: { name, value },
    disabled,
    eventEmitter,
    showError,
    existError,
    ...other
  } = props;
  const [localValue, setValueLocal] = useState(getCorrectDate(value));

  // TODO observable value
  useEffect(() => {
    setValueLocal(getCorrectDate(value));
  }, [value]);

  // observable localValue
  useEffect(() => {
    eventEmitter(localValue);
  }, [localValue]);

  // on change value
  const onChange = event => setValueLocal(getCorrectDate(get(event, 'target.value')));

  return (
    <input
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      className={addClassName({ existError, showError })}
      name={name}
      disabled={disabled}
      type="date"
      value={localValue || ''}
      onChange={onChange}
    />
  );
};

DateCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  disabled: PropTypes.bool,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
};

DateCommon.defaultProps = {
  field: {
    value: undefined,
  },
  existError: false,
  showError: false,
  disabled: false,
};

export default DateCommon;
